import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { BLUE_PRIMARY, DARK_SIDEBAR, WHITE } from "../../utils/const";
import InfoIcon from "@material-ui/icons/Info";
import { Link } from "react-router-dom";
const SimpleTable = ({
  hasIndex,
  hasLink,
  navigation,
  header,
  data,
  darkHeader,
  page,
  count,
  newPageLink,
  clickFucntion,
}) => {
  const headerStyles = darkHeader
    ? { backgroundColor: DARK_SIDEBAR, color: WHITE }
    : null;
  return (
    <TableContainer
      component={Paper}
      style={{ marginTop: "12px", marginBottom: "12px" }}
    >
      <Table sx={{ maxWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {hasIndex ? (
              <TableCell style={headerStyles} align={"center"}>
                #
              </TableCell>
            ) : null}
            {header.map((item) => (
              <TableCell style={headerStyles} align="center">
                {item.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length > 0
            ? data.map((item, idx) => {
                return (
                  <TableRow>
                    {hasIndex ? (
                      <TableCell align={"center"}>
                        {page ? (page - 1) * count + idx + 1 : idx + 1}
                      </TableCell>
                    ) : null}
                    {header.map((value, index) => {
                      if (!!hasLink && index === header.length - 1) {
                        return (
                          <TableCell
                            onClick={
                              clickFucntion
                                ? () => {
                                    clickFucntion();
                                  }
                                : null
                            }
                            align="center"
                          >
                            <Link
                              to={`${navigation}/${item[value.key]}`}
                              target={newPageLink ? "_blank" : ""}
                            >
                              <InfoIcon
                                style={{
                                  color: BLUE_PRIMARY,
                                  cursor: "pointer",
                                }}
                              />
                            </Link>
                          </TableCell>
                        );
                      }
                      return (
                        <TableCell align="center">{item[value.key]}</TableCell>
                      );
                    })}
                  </TableRow>
                );
              })
            : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default SimpleTable;
